<template>
    <div id="ficheCategorie">
        <b-row class="backInfoMain2">

            <menuSave 
                :msg="sendMsg" 
                newBtn 
                :btnSaveDisabled="checkAllField" 
                @new="menuNew()" 
                saveBtn 
                @save="menuSave()" 
                :deleteBtn="checkDeleteBtn"
                @delete="menuDelete(activeObj.id)"
                :msgText="sendMsg2"
                :msgType="getTheme.primary">
            </menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <s-itemList 
                    v-if="categoryList"
                    :content="categoryList" 
                    :returnValue.sync="activeObj"
                    activeField="isActive" 
                    :selectedItems="activeObj"
                    multiColonne
                    :fields="fields"
                    @getRowdDetail="getRowdDetail"
                    >
                </s-itemList>
            </b-col>
            <!--Fin section de gauche-->
            
<!--****************************************************************************************************************************************************************-->
            
            <!--Section du centre-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">

                <!--INFORMATIONS DE LA CATEGORIE -->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <div class="itemMain">
                            <div class="itemSubTitle">{{$t('s_Informations')}}</div>
                            <div class="itemContain">
                                <s-input id = "name" name="name" type="text" maxlength="40" class="MargeTop15" :placeholder="$t('cat_Name')" v-capitalize v-model="activeObj.categoryName" :state="isValid(activeObj.categoryName)"></s-input>
                                
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <!--FIN - Section de droite-->
            <b-col :class="getAllSize.pagePadTop" :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" xl="3">

            </b-col>
        </b-row>
        
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import menuSave from '@/components/general/s-menuSave/s-menuSave.vue'
import {dataService} from '@/services'
import SocketioService from '@/plugins/socket/socketio.service.js'
import store from '@/store'

export default{
    name: "ficheCategorie",
    mixins:[mapGetter],
    components: {
        menuSave,
    },
    data() {
        return{
            InitialState: null, //Format initial de : activeObj
            activeObj:{}, //Créé à l'ouverture à partir du modèle vide dans l'api
            originalObj : {},
            fields:[
                {
                    colName: "id",
                    label: "id",
                    show: false,
                },
                {
                    colName: "categoryName",
                    label: this.$i18n.t('cat_Name') ,
                    show: true,
                },
            ], 
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            sendMsg2: 'vide', //message a utiliser pour le menu en haut de la page New/Save/Delete
        
        }
    },
    methods: {
        isValid : (str) => (!(str === "undefined" || str?.length == 0)), //Valide si le champs n'est pas indefini ni vide
        /**
         * Reinitialise tous les champs de la fiche catégorie
         */
        resetAll(){
            this.activeObj = this.$CObj(this.InitialState)
            this.originalObj = this.$CObj(this.activeObj)
        },
        /**
         * Crée un nouveau fiche catégorie vide
         */
        menuNew(){
            this.resetAll()
        },
        /**
         * Charge les données des catégories 
         */
        loadApi() {            
            if(typeof this.payload?.data?.categoryList == 'undefined') {
                //Charger les catégories depuis le serveur si ils ne sont pas présent locallement
                this.sendMsg = '4'
                dataService.getCategories()
                .then(response => {
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg = ''
                        let data = response.data;
                        return data;
                    }
                })
                .then(response => {
                    console.log(response)
                    this.categoryList = this.$CObj(response.data.categoryList)
                    this.InitialState = this.$CObj(response.addons.classes.categoryList[0])
                    this.activeObj = this.$CObj(this.InitialState)
                    this.originalObj = this.$CObj(this.InitialState)
                })
                .catch(error =>{
                    this.sendMsg = ''
                    console.log(error);
                })

            } else {
                //Les données chargées depuis le localStorage
                this.InitialState = this.$CObj(this.payload.addons.classes.categoryList[0])
                this.activeObj = this.$CObj(this.InitialState)
                this.originalObj = this.$CObj(this.InitialState)
            }
        },
        /**
         * Sauvegarde la fiche catégorie
         */
        menuSave(){
            let t = this.activeObj
            if (t.id == 0) //CRÉATION D'UN NOUVEAU
            {
                this.sendMsg = '-'
                dataService.addCategory(t)
                .then((response) => {
                    console.log(response)
                    if(response.statusText == 'OK')
                    {
                        this.sendMsg2 ='add Category OK';
                        this.sendMsg = ''
                        const newCategory = response.data.data
                        SocketioService.getSocket().emit('afterInsert', {action: 'afterInsert', storeName:'categories', payload: newCategory});
                        this.categoryList.unshift(newCategory)
                        this.resetAll()
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if(error.data.data == "") {
                        this.sendMsg2 = error.data.addons.errorFr;
                    }
                });
            }
            else //MODIFICATION D'UN EXISTANT
            {
                this.sendMsg = '-'
                dataService.updateCategory(t)
                .then((response) => {
                    if(response.statusText == 'OK')
                    {
                        if(response.data)
                        {
                            this.sendMsg2 ='update OK';
                            const updatedCategory = response.data.data
                            SocketioService.getSocket().emit('afterUpdate', {action: 'afterUpdate', storeName:'categories', payload: updatedCategory});
                            this.categoryList = this.categoryList.map(category => {
                                if(category.id == updatedCategory.id)  Object.assign(category, updatedCategory) ;
                                return category;
                            });
                            this.resetAll()
                        }
                    }
                    this.sendMsg = ''
                })
                .catch((error) => {
                    this.sendMsg = ''
                    console.log(error);
                    alert('update KO');
                });
            }
            setTimeout(() => { this.sendMsg = '' }, 5000)
        },
        /**
         * Désactive la fiche catégorie
         * @param {int} id - id de la catégorie
         */
        menuDelete(id){
            if (id == '0') return;
            this.sendMsg = '-'
            dataService.deleteCategory(id)
            .then((response) => {
                if(response.statusText == 'OK')
                {   
                    this.sendMsg = ''
                    SocketioService.getSocket().emit('afterDelete', {action: 'afterDelete', storeName:'categories', payload: {id:id, isActive:false}});
                    this.categoryList = this.categoryList.map(category => {
                        if(category.id == id)  category.isActive = !category.isActive;
                        return category;
                    });
                    this.resetAll()
                }
                this.sendMsg = ''
            })
            .catch((error) => {
                this.sendMsg = '';
                console.log(error);
            });
        },
        /**
         * Retourne les détails de la catégorie 
         * @param {int} id - id de la catégorie
         */
        getRowdDetail(id)
        {
            this.sendMsg = '-'
            let category = this.categoryList.find(cat => typeof cat !== 'undefined' && cat.id == id);
            
            if(category)
            {
                this.activeObj = this.$CObj(category)
                this.sendMsg2 ='getCategory OK';
                this.originalObj = this.$CObj(this.activeObj)
                this.InitialState = this.$CObj(this.payload.addons.classes.categoryList[0])
            }
            this.sendMsg = ''
        },

        
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        /**
         * Vérifie s'il ya des modifications
         */
        checkAllField() {
            return JSON.stringify(this.originalObj) == JSON.stringify(this.activeObj)
        },
        /**
         * Vérifie si on autorise la désactivation du client
         */
        checkDeleteBtn() {
            return (this.activeObj.id != 0)
        },
        /**
         * Retourne le payload sauvegardé dans le local
         */
         payload : () => store.getters.getInventory,
        /**
         * Retourne la liste des categories du payload
         */
         categoryList() {return this.payload?.data.categoryList},
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.loadApi() 
    },
//------------------------------------------------------------------------------------------------
    watch: {
        sendMsg: function() {
            if (this.sendMsg == '1')
            {
                this.resetAll()
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>